import type { Accommodation } from "@@/shared/acquire/accommodation";
import type { Product } from "@@/shared/products/product";

const getAccommodationFromProduct = (product: Product) => {
    const accommodationSku = product.skus.find(
        sku => sku.acquire._type === "ACCOMMODATION",
    );

    if (!accommodationSku) {
        return null;
    }

    return accommodationSku.acquire as Accommodation;
};

export { getAccommodationFromProduct };
